// // src/features/location/locationSlice.js

// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   selectedLocation: "Belagavi", // Default location
// };

// const locationSlice = createSlice({
//   name: "location",
//   initialState,
//   reducers: {
//     setLocation: (state, action) => {
//       state.selectedLocation = action.payload;
//     },
//   },
// });

// export const { setLocation } = locationSlice.actions;
// export default locationSlice.reducer;



// src/Redux/Slice/locationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedLocation: "Select Location",
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setLocation: (state, action) => {
      state.selectedLocation = action.payload;
    },
  },
});

export const { setLocation } = locationSlice.actions;
export default locationSlice.reducer;
